import { constants, MarketingBanner } from "@newsela/angelou";

import { useFetchLicenses } from "@/base/NewselaGlobalLayoutV2/NavigationBar/PremiumTrial/TrialBanner/hooks/useFetchLicenses";
import {
  trialBannerCss,
  trialTextCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/PremiumTrial/TrialBanner/TrialBanner.styles";
import { getTrialBannerDaysHoursText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/PremiumTrial/TrialBanner/TrialBanner.utils";
import MapSvg from "@/icons/MapIcon/MapIcon";
import WarningSvg from "@/icons/WarningIcon2/WarningIcon2";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import getTrialLicenseFarthestExpirationDate from "@/utils/getTrialLicenseFarthestExpirationDate";

export const TrialBanner = ({ hideHeader = false }: ITrailBanner) => {
  const { data: user } = useUser();

  const {
    isStudent,
    hasPremiumLicense,
    hasPaidEssentialsLicense,
    hasActivePremiumTrialCampaign,
    hasNceTrialCampaign,
    hasSchoolPocLicense,
  } = getUserProperties(user, { shouldUseNewUserApi: false });

  const licenses = useFetchLicenses();

  const {
    daysToExpiration,
    hoursToExpiration,
    active: hasActiveTrial,
    isSchoolTrial: isSchoolWideTrial,
  } = getTrialLicenseFarthestExpirationDate(licenses);

  if (
    !hasActivePremiumTrialCampaign ||
    !hasActiveTrial ||
    isStudent ||
    hasPremiumLicense ||
    hasNceTrialCampaign ||
    hasSchoolPocLicense ||
    hasPaidEssentialsLicense ||
    hideHeader ||
    !user?.is_authenticated
  )
    return null;

  const SvgComponent = daysToExpiration >= 5 ? MapSvg : WarningSvg;
  const bannerBackground =
    daysToExpiration >= 5
      ? constants.colors.ui.purple[500]
      : constants.colors.ui.red[600];

  return (
    <MarketingBanner
      isCenter
      saturation="light"
      color="yellow"
      SvgComponent={SvgComponent}
      __cssFor={trialBannerCss(bannerBackground)}
      __renderBody={() => (
        <p
          style={trialTextCss}
          data-testid={`trial-banner-${bannerBackground}`}
        >
          You have&nbsp;
          <b>
            {getTrialBannerDaysHoursText({
              daysToExpiration,
              hoursToExpiration,
            })}
          </b>
          left on your {isSchoolWideTrial ? "school-wide " : ""}trial.
        </p>
      )}
    />
  );
};

interface ITrailBanner {
  hideHeader?: boolean;
}
